angular.module('service-request.status', [ 'service-request' ])
    .service('ServiceRequestStatusService', function (modals, ServiceRequest){
        this.statuses = [ 'FILLED', 'INVESTIGATION', 'IMPLEMENTATION', 'COMPLETED', 'CLOSED', 'SUSPENDED', 'REJECTED', 'CANCELLED' ]

        this.statusChange = (id) => {
            return ServiceRequest.get({id: id}).$promise.then(item => {
                return modals.open('app/service-request/status/status-change.html', 'ServiceRequestStatusDialogController', item, {size: "sm"}, "$ctrl");
            });
        };
    })
    .controller('ServiceRequestStatusDialogController', function ($rootScope, $uibModalInstance, data, ServiceRequest, ServiceRequestConst) {
        this.req = data;
        this.item = {
            id: data.id,
            filledInAt: data.filledInAt,
            allowedTime: data.allowedTime,
            registeredAt: data.registeredAt,
            claimImplementation: data.claimImplementation,
            closedAt: data.closedAt
        };

        this.commentField = true;

        this.operationStatus = {
            FILLED: {
                statuses: [ 'INVESTIGATION', 'SUSPENDED', 'REJECTED', 'CANCELLED' ]
            },
            INVESTIGATION: {
                statuses: [ 'IMPLEMENTATION', 'COMPLETED', 'CLOSED', 'SUSPENDED', 'REJECTED', 'CANCELLED' ]
            },
            IMPLEMENTATION: {
                statuses: [ 'SUSPENDED', 'COMPLETED' ]
            },
            COMPLETED: {
                statuses: [ 'SUSPENDED', 'CLOSED' ]
            },
            CLOSED: {
                statuses: [ 'INVESTIGATION' ]
            },
            SUSPENDED: {
                statuses : [ 'INVESTIGATION', 'IMPLEMENTATION', 'REJECTED', 'CANCELLED' ],
                commentFieldRequired: true
            },
            REJECTED : {
                statuses : [ 'INVESTIGATION' ],
                commentFieldRequired: true
            },
            CANCELLED: {
                statuses: [ 'INVESTIGATION' ],
                commentFieldRequired: true
            }
        };

        this.$onInit = () => {
            this.statuses = this.operationStatus[this.req.status].statuses;
            if(this.statuses.length === 1){
                this.item.status = this.statuses[0]
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let toSave = angular.copy(this.item);
            return ServiceRequest.statusChange(toSave, onSaveSuccess, () => {});
        };

        let onSaveSuccess = result => {
            $rootScope.$broadcast(ServiceRequestConst.eventUpdate);
            $uibModalInstance.close(result);
        };
    })
    .component('serviceRequestStatusLabel', {
        bindings: {
            status: '<'
        },
        template: '<span class="label label-default service-request-status {{$ctrl.status}}">{{ \'service-request.status.\'.concat($ctrl.status) | translate }}</span>'
    })
